import './AdminPage.css'

import { useMutation } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import { addUserToGroups, adminConfirmUser, registerForTest } from '../../../api/auth/auth.api'
import environment from '../../../environment'
import checkIcon from '../../../imgs/check.png'
import editIcon from '../../../imgs/edit.png'
import cancelIcon from '../../../imgs/remove.png'
import { generateWarehouseReport } from '../../../services/packages'
import { setRatesAction } from '../../../store/packageSlice'

export default function AdminPage() {
  const { loggedUser } = useSelector(state => state.user)
  const { EURToUSD, GBPToUSD, poalimRate, BOIrate, ratesObjUpdatedAt } = useSelector(state => state.packages)
  const dispatch = useDispatch()

  const [editMode, seteditMode] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [ratesObj, setRatesObj] = useState({})
  // const [workersArray, updateWorkersArray] = useState([])

  const [createUserError, setCreateUserError] = useState('')
  const [createUserSuccess, setCreateUserSuccess] = useState('')
  const [isCreatingUser, setIsCreatingUser] = useState(false)
  const [availableGroups] = useState(['Admin', 'Agent', 'OfficeManager', 'SeniorAgent', 'Worker'])

  // Warehouse reports state
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date()
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
  })

  // Warehouse reports mutation
  const warehouseReportMutation = useMutation({
    mutationFn: ({ warehouse, month }) => generateWarehouseReport(warehouse, month),
    onSuccess: (data, { warehouse, month }) => {
      // Create download link
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.download = `${warehouse}_warehouse_report_${month}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    onError: error => {
      console.error('Error generating warehouse report:', error)
    },
  })
  const [newUserData, setNewUserData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    street: '',
    streetNum: '',
    city: '',
    zipCode: '',
    subscribe: false,
    selectedGroups: [],
  })

  useEffect(() => {
    if (EURToUSD)
      setRatesObj({
        updatedAt: ratesObjUpdatedAt.split('T')[0],
        poalimRate: poalimRate,
        EURToUSD: EURToUSD,
        GBPToUSD: GBPToUSD,
        BOIrate: BOIrate,
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [EURToUSD])

  // const getAndHandleWorkersData = async () => {
  //   const workers_arr = await getAllWorkers()
  //   updateWorkersArray(workers_arr)
  // }

  const updateRatesObjDB = async () => {
    setisLoading(true)
    try {
      await dispatch(
        setRatesAction({
          poalimRate: parseFloat(ratesObj.poalimRate),
          EURToUSD: parseFloat(ratesObj.EURToUSD),
          GBPToUSD: parseFloat(ratesObj.GBPToUSD),
          BOIrate: parseFloat(ratesObj.BOIrate),
        })
      )

      seteditMode(false)
    } catch (error) {
      console.log(error)
    }
    setisLoading(false)
  }

  // const addWorkerOffice = async () => {
  //   const workerID = prompt('Worker Email')
  //   if (!workerID || workerID === '') {
  //     alert('Wrong Or Empty Email')
  //   }

  //   await addRoleWorkerToUser(workerID)
  // }

  // User creation functions
  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    setNewUserData({
      ...newUserData,
      [name]: type === 'checkbox' ? checked : value,
    })
  }

  const handleGroupChange = group => {
    const updatedGroups = [...newUserData.selectedGroups]
    if (updatedGroups.includes(group)) {
      const index = updatedGroups.indexOf(group)
      updatedGroups.splice(index, 1)
    } else {
      updatedGroups.push(group)
    }
    setNewUserData({ ...newUserData, selectedGroups: updatedGroups })
  }

  const whiteSpacesCheck = str => str.trim()

  const handleCreateUser = async () => {
    setIsCreatingUser(true)
    setCreateUserError('')
    setCreateUserSuccess('')

    try {
      if (
        !newUserData.firstName ||
        !newUserData.lastName ||
        !newUserData.email ||
        !newUserData.phone ||
        !newUserData.password ||
        !newUserData.street ||
        !newUserData.streetNum ||
        !newUserData.city ||
        !newUserData.zipCode
      ) {
        throw new Error('Please fill in all required fields')
      }

      const signUpData = {
        username: whiteSpacesCheck(newUserData.email),
        password: newUserData.password,
        phone_number: '+972' + newUserData.phone,
        name: whiteSpacesCheck(newUserData.firstName),
        family_name: whiteSpacesCheck(newUserData.lastName),
        adress: newUserData.street || '',
        apartment: newUserData.streetNum || '',
        city: newUserData.city || '',
        postalcode: newUserData.zipCode || '',
        refNum: '',
        refBy: '',
        subscribe: newUserData.subscribe.toString(),
      }

      const response = await registerForTest(
        `phone_number ^= \"${signUpData.phone_number}\"`,
        `email ^= \"${signUpData.username}\"`,
        signUpData
      )

      if (environment.isProd) {
        if (response.data.internalCode === 1) {
          setCreateUserSuccess('User created successfully!')
        } else {
          throw new Error(response.data.response?.message || 'Error creating user')
        }
      }

      if (environment.isDev) {
        //check created well
        if (response.data.internalCode === 1) {
          //confirm user automatically
          try {
            await adminConfirmUser(response.data.response.UserSub)
            setCreateUserSuccess('User created and verified successfully!')
          } catch (confirmError) {
            console.error('Error confirming user:', confirmError)
            setCreateUserSuccess('User created successfully, but could not auto-verify.')
          }

          //add the users to groups
          if (newUserData.selectedGroups.length > 0) {
            await addUserToGroups(newUserData.email, newUserData.selectedGroups)
          }
        } else {
          throw new Error(response.data.response?.message || 'Error creating user')
        }
      }
    } catch (error) {
      console.error('Error creating user:', error)
      setCreateUserError(error.response?.data?.message || error.message || 'Error creating user')
    } finally {
      setIsCreatingUser(false)
    }
  }
  const ClearFields = () => {
    setNewUserData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
      street: '',
      streetNum: '',
      city: '',
      zipCode: '',
      subscribe: false,
      selectedGroups: [],
    })
    setCreateUserError('')
    setCreateUserSuccess('')
  }

  // Warehouse report handler
  const handleWarehouseReport = warehouse => {
    warehouseReportMutation.mutate({ warehouse, month: selectedMonth })
  }

  return (
    <section className='eau-adminpage-cont'>
      <h3>Exchange Rates </h3>

      {!ratesObj.EURToUSD ? (
        <Spinner animation='border' variant='primary' />
      ) : (
        <div className='adminpage-rates-table-cont'>
          <table className='adminpage-rates-table'>
            <thead>
              <tr>
                <th>USD - NIS (Poalim)</th>
                <th>USD - NIS BOI</th>
                <th>EUR - USD</th>
                <th>GBP - USD</th>
                <th>Last Update</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    value={ratesObj.poalimRate}
                    onChange={e =>
                      setRatesObj({
                        ...ratesObj,
                        poalimRate: e.target.value,
                      })
                    }
                    disabled={!editMode}
                  />
                </td>

                <td>
                  <input
                    value={ratesObj.BOIrate}
                    onChange={e =>
                      setRatesObj({
                        ...ratesObj,
                        BOIrate: e.target.value,
                      })
                    }
                    disabled={!editMode}
                  />
                </td>

                <td>
                  <input
                    value={ratesObj.EURToUSD}
                    onChange={e =>
                      setRatesObj({
                        ...ratesObj,
                        EURToUSD: e.target.value,
                      })
                    }
                    disabled={!editMode}
                  />
                </td>

                <td>
                  <input
                    value={ratesObj.GBPToUSD}
                    onChange={e =>
                      setRatesObj({
                        ...ratesObj,
                        GBPToUSD: e.target.value,
                      })
                    }
                    disabled={!editMode}
                  />
                </td>

                <td> {ratesObj.updatedAt}</td>
              </tr>
            </tbody>
          </table>

          <div className='eau-user-details-edit'>
            {!editMode ? (
              <img src={editIcon} onClick={() => seteditMode(true)} disabled={!loggedUser.permissions['Admin']} />
            ) : (
              <>
                {!isLoading ? (
                  <>
                    <img src={checkIcon} onClick={updateRatesObjDB} style={{ marginRight: '50px' }} />
                    <img src={cancelIcon} onClick={() => seteditMode(false)} />
                  </>
                ) : (
                  <Spinner animation='border' variant='primary' />
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* Warehouse Monthly Reports Section */}
      <div className='auf-admin-section'>
        <h3>Warehouse Monthly Reports</h3>
        <div className='warehouse-reports-container'>
          <div className='mb-4'>
            <label htmlFor='month-selector' className='mr-2'>
              Select Month:
            </label>
            <input
              type='month'
              id='month-selector'
              value={selectedMonth}
              onChange={e => setSelectedMonth(e.target.value)}
              className='warehouse-month-input'
            />
          </div>
          <div className='warehouse-reports-buttons'>
            <button
              className='warehouse-report-btn warehouse-report-btn-us'
              onClick={() => handleWarehouseReport('USA')}
              disabled={warehouseReportMutation.isPending}
            >
              {warehouseReportMutation.isPending ? <Spinner animation='border' size='sm' /> : 'Generate USA Report'}
            </button>
            <button
              className='warehouse-report-btn warehouse-report-btn-uk'
              onClick={() => handleWarehouseReport('UK')}
              disabled={warehouseReportMutation.isPending}
            >
              {warehouseReportMutation.isPending ? <Spinner animation='border' size='sm' /> : 'Generate UK Report'}
            </button>
            <button
              className='warehouse-report-btn warehouse-report-btn-gr'
              onClick={() => handleWarehouseReport('GR')}
              disabled={warehouseReportMutation.isPending}
            >
              {warehouseReportMutation.isPending ? <Spinner animation='border' size='sm' /> : 'Generate GR Report'}
            </button>
          </div>
          {warehouseReportMutation.isError && (
            <div className='auf-error'>
              Failed to generate warehouse report: {warehouseReportMutation.error?.message || 'Unknown error'}
            </div>
          )}
          {warehouseReportMutation.isSuccess && <div className='auf-success'>Warehouse report generated and downloaded successfully!</div>}
        </div>
      </div>

      {/* User Management Section */}
      <div className='auf-admin-section'>
        <h3>Add User</h3>
        {environment.isProd && (
          <div className='auf-error'>
            You currently on production mode, after creating user, the user will be on test env and you must verify him and add to groups{' '}
            <b>manually</b>
          </div>
        )}
        {environment.isDev && (
          <div className='auf-success'>
            You currently on test / dev mode, the user will be created in test env and will be verified and added to the groups you choose{' '}
            <b>automatically</b>
          </div>
        )}
        {
          <div className='auf-create-form'>
            <form
              onSubmit={e => {
                e.preventDefault()
                handleCreateUser()
              }}
            >
              <div className='auf-form-row'>
                <div className='auf-form-group auf-col-half'>
                  <label htmlFor='firstName'>First Name*</label>
                  <input type='text' id='firstName' name='firstName' value={newUserData.firstName} onChange={handleInputChange} required />
                </div>
                <div className='auf-form-group auf-col-half'>
                  <label htmlFor='lastName'>Last Name*</label>
                  <input type='text' id='lastName' name='lastName' value={newUserData.lastName} onChange={handleInputChange} required />
                </div>
              </div>

              <div className='auf-form-row'>
                <div className='auf-form-group auf-col-half'>
                  <label htmlFor='email'>Email*</label>
                  <input type='email' id='email' name='email' value={newUserData.email} onChange={handleInputChange} required />
                </div>
                <div className='auf-form-group auf-col-half'>
                  <label htmlFor='phone'>Phone Number* (without +972)</label>
                  <input
                    type='text'
                    id='phone'
                    name='phone'
                    value={newUserData.phone}
                    onChange={handleInputChange}
                    placeholder='e.g. 0501234567'
                    required
                  />
                </div>
              </div>

              <div className='auf-form-group'>
                <label htmlFor='password'>Password*</label>
                <input type='password' id='password' name='password' value={newUserData.password} onChange={handleInputChange} required />
              </div>

              <div className='auf-form-row' style={{ marginTop: '20px' }}>
                <div className='auf-form-group auf-col-large'>
                  <label htmlFor='street'>Street*</label>
                  <input type='text' id='street' name='street' value={newUserData.street} onChange={handleInputChange} required />
                </div>
                <div className='auf-form-group auf-col-small'>
                  <label htmlFor='streetNum'>Street Number*</label>
                  <input type='text' id='streetNum' name='streetNum' value={newUserData.streetNum} onChange={handleInputChange} required />
                </div>
              </div>

              <div className='auf-form-row'>
                <div className='auf-form-group auf-col-half'>
                  <label htmlFor='city'>City*</label>
                  <input type='text' id='city' name='city' value={newUserData.city} onChange={handleInputChange} required />
                </div>
                <div className='auf-form-group auf-col-half'>
                  <label htmlFor='zipCode'>Zip Code*</label>
                  <input type='text' id='zipCode' name='zipCode' value={newUserData.zipCode} onChange={handleInputChange} required />
                </div>
              </div>

              <div className='auf-form-group auf-checkbox' style={{ direction: 'ltr' }}>
                <label>
                  <input type='checkbox' name='subscribe' checked={newUserData.subscribe} onChange={handleInputChange} />
                  {` Subscribe to newsletter`}
                </label>
              </div>

              {environment.isDev && (
                <div className='auf-form-group' style={{ marginTop: '20px' }}>
                  <label>User Groups</label>
                  <div className='auf-checkbox-container'>
                    {availableGroups.map(group => (
                      <label key={group} className='auf-checkbox-label'>
                        <input
                          type='checkbox'
                          id={`group-${group}`}
                          checked={newUserData.selectedGroups.includes(group)}
                          onChange={() => handleGroupChange(group)}
                        />
                        {group}
                      </label>
                    ))}
                  </div>
                </div>
              )}
              {isCreatingUser ? (
                <Spinner animation='border' variant='primary' />
              ) : (
                <>
                  {createUserError && <div className='auf-error'>{createUserError}</div>}
                  {createUserSuccess && <div className='auf-success'>{createUserSuccess}</div>}

                  <div className='auf-form-actions'>
                    <button type='button' className='auf-cancel-btn' onClick={() => ClearFields()}>
                      Clear
                    </button>
                    <button type='submit' className='auf-submit-btn'>
                      Create User
                    </button>
                  </div>
                </>
              )}
            </form>
          </div>
        }
      </div>
      {/* <Container>
        <Row>
          <Col style={{ textAlign: "center" }}>
            <Alert style={{ textAlign: "left" }} variant="primary">
              Workers-Manage your workers , add and delete , just be carful
            </Alert>
          </Col>
        </Row>
       {loggedUser.permissions["Admin"] && <Table className="editAndUpdate-table">
          <thead>
            <tr>
              <td colSpan="4">
                <Button
                  variant="light"
                  style={{ backgroundColor: "lightgrey" }}
                  onClick={addWorkerOffice}
                >
                  Add Worker
                </Button>
              </td>
            </tr>
            <th>Worker Name </th>
            <th>Worker Email </th>
            <th> Worker ID </th>
            <th> Action </th>
          </thead>
          <tbody>
            {workersArray.map((worker) => {
              return <WorkersDetailsRow workerObj={worker.Attributes} />;
            })}
          </tbody>
        </Table>}
      </Container> */}
    </section>
  )
}

// function WorkersDetailsRow(props) {
//   const { workerObj } = props
//   const detailsObj = {
//     name: '',
//     familyname: '',
//     email: '',
//     id: '',
//   }
//   const [workerState, updateWorkerState] = useState(detailsObj)

//   const handleWorkerData = () => {
//     const name = workerObj.find((field) => field.Name === 'name')
//     const lastname = workerObj.find((field) => field.Name === 'family_name')
//     const email = workerObj.find((field) => field.Name === 'email')
//     const id = workerObj.find((field) => field.Name === 'sub')

//     updateWorkerState({
//       ...workerState,
//       name: name?.Value,
//       familyname: lastname?.Value,
//       email: email?.Value,
//       id: id?.Value,
//     })
//   }

//   useEffect(() => {
//     if (workerObj) {
//       handleWorkerData()
//     }
//   }, [props])

//   return (
//     <tr>
//       <td>{workerState.name}</td>
//       <td>{workerState.email}</td>
//       <td>{workerState.id}</td>
//       <td>
//         <Button onClick={() => removeRoleWorkerToUser(workerState.email)} variant="danger" disabled={!loggedUser.permissions['Admin']}>
//           Delete Worker
//         </Button>
//       </td>
//     </tr>
//   )
// }
